const COOKIE_KEYS = {
  THEME: "_color_theme",
};

const THEME_OPTIONS = [
  { label: "System", value: "system" },
  { label: "Light", value: "light" },
  { label: "Dark", value: "dark" },
] as const;
type ThemeOption = (typeof THEME_OPTIONS)[number]["value"];

export { COOKIE_KEYS, THEME_OPTIONS, type ThemeOption };
